export const ROUTE_BATCH_RECORDS = 'batch-records';
export const ROUTE_MACHINES = 'machines';
